/**
 * @param {string} page Type of page
 */

export function HookReadMoreActions ( page ) {
    let readMoreContainers = document.querySelectorAll('.mobile-read-more-switch')
    readMoreContainers.forEach((container) => {
      let showButton = container.querySelector('.show')
      let hideButton = container.querySelector('.hide')
      showButton.addEventListener('click', (event) => {
        mobileReadMore(event, 'show', page)
      })
      hideButton.addEventListener('click', (event) => {
        mobileReadMore(event, 'hide', page)
      })
    })
  
}
  
/**
 * Open and hide text
 * 
 * @param {object} event  Pointer event
 * @param {string} action Show or hide
 * @param {string} page   Type of page
 */
function mobileReadMore (event, action, page) {
    let parent = event.target.parentNode
    let parentData = parent.getAttribute('data');
  
    if (action === 'show') {
      parent.classList.remove('show-content')
      parent.classList.add('hide-content')
      let targetElement = document.querySelector('.' + parentData)
      targetElement.classList.remove('mobile-read-more');

      if ( page === 'trainer' ) {
        targetElement.classList.remove('mobile-read-more--trainer');
      }

    }
    if (action === 'hide') {
      parent.classList.remove('hide-content')
      parent.classList.add('show-content')
      let targetElement = document.querySelector('.' + parentData)
      targetElement.classList.add('mobile-read-more');

      if ( page === 'trainer' ) {
        targetElement.classList.add('mobile-read-more--trainer');
      }
      targetElement.scrollIntoView({
        behavior:'smooth',
        block: "center",
      })
    }
}
